import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fahwyq7pyr9h">
      <div className="min-h-screen bg-white font-sans text-[#1a1a1a] selection:bg-[#c06a2b] selection:text-white" data-id="element-1" data-mp="3fa87r4ui0o4u">
        <Navbar data-id="element-2" data-mp="2rlyoa9krccgv" />

        <Routes data-id="element-3" data-mp="2rlfbf79yse9p">
          <Route path="/" element={<HomePage data-id="element-5" data-mp="2mm2luerpkt3f" />} data-id="element-4" data-mp="2rit3h6j5vwqy" />
          <Route path="/about" element={<AboutPage data-id="element-7" data-mp="2mndna7xolord" />} data-id="element-6" data-mp="2mmlvz9b4ad6w" />
        </Routes>

        <Footer data-id="element-8" data-mp="31agoaol7qfjg" />
      </div>
    </BrowserRouter>;
}